export default __webpack_public_path__ + "static/media/documents-icon.16591a0c.png";